<p-confirmDialog></p-confirmDialog>
<p-toast  position="top-right"></p-toast>
<div class="map-form-container flex flex-column">
  <div>

  </div>
  <div class="map-section p-2 col-12 position-relative">
    <!-- Checkbox overlay - left side -->
    <div class="show-crop-toggle">
      <app-checkbox
        [(ngModel)]="showCrops"
        [label]="'Show_crops' | translate"
      ></app-checkbox>
      <msf-form-builder
        [fields]="getEditSourceForm()"
        [(model)]="config.data.model"
        flexDirection="row"
      ></msf-form-builder>
    </div>

    <mfs-old-map
      [height]="'100%'"
      [zoom]="13"
      [isSplitControl]="canSplit"
      [drawingMode]="!showCrops"
      (markerClick)="onMarkerClick($event)"
      [(geometry)]="config.data.model.polygon"
      [isCenterMarker]="false"
      [showControls]="true"
      [isCenterControl]="false"
      [polygonJson]="showCrops ? null : formData?.polygonJson"
      [multiPolygonJsonColors]="showCrops ? multiPolygonJson : []"
      [splitLabels]="['Old' | translate, 'New'| translate]"
      [(splitPolygons)]="splitPolygons"
    ></mfs-old-map>

  </div>
  <div class="flex flex-row justify-content-end align-items-end mt-3 gap-2">
    <p-button
      [severity]="'secondary'"
      label="{{ 'Close' | translate }}"
      class="p-button-text button-secondary"
      (click)="cancel()"
    ></p-button>
    <button
      pButton type="button"
      label="{{ 'Apply' | translate }}"
      class="p-button-primary"
      (click)="save()"
      [loading]="isLoading"
    ></button>
  </div>
</div>
